export default __webpack_public_path__ + "static/media/meltdown.94ef29ef.jpg";